import * as HttpService from 'services/http.service';
import { CONTACT_US, CONTACT_US_USER } from 'services/url.service';

export const contactUs = (data) =>
  HttpService.postWithoutAuth(CONTACT_US, data);

export const userContactUs = (contactDetails) =>
  HttpService.postWithAuth(CONTACT_US_USER, contactDetails);
